import React, { useEffect, useState } from 'react';
import { Issue, Solution } from '../models/Issue';
import { Container, Box, Typography, Accordion, AccordionSummary, AccordionDetails, IconButton, Link } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import HelpVideoAccordianComponent from './HelpVideoComponent';
import workAnalyzerService from '../services/workAnalyzerService';
import ProfessionalNearbyComponent from './ProfessionalNearbyComponent';
import AccordianSolutionComponent from './AccordianSolutionComponent';

interface IssueAnswerComponentProps {
  issue: Issue;
  openGlossary: () => void; // Add this prop for opening glossary
  conversationId: string;
}

const IssueAnswerComponent: React.FC<IssueAnswerComponentProps> = ({ issue, openGlossary, conversationId }) => {
  const { Answer } = issue;

  const [videoLinks, setVideoLinks] = useState<string[] | null>(null);

  const getVideoLinksFromIssue = async (id : string) => {
    const embeddableLinks = await workAnalyzerService.getVideoLinks(id);
    setVideoLinks(embeddableLinks);
  }
  
  useEffect(() => {
    getVideoLinksFromIssue(conversationId);
  }, [conversationId]);

  return (
    <Container component="main" maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box sx={{ mt: 4, width: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography component="h1" variant="h5" gutterBottom>
            Diagnosis
          </Typography>
          <IconButton color="primary" aria-label="open glossary" onClick={openGlossary} sx={{ ml: 2 }}>
            <Typography variant="body2" sx={{ mr: 0.5 }}>Glossary</Typography>
            <MenuBookIcon sx={{ fontSize: 24 }} />
          </IconButton>
        </Box>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {Answer.Diagnosis}
        </Typography>

        { Answer.projectedCostLow ?
        <Typography variant='body1' color="darkgreen" style={{marginBottom:15}}>
          Projected professional cost: ${Answer.projectedCostLow ?? "unknown"} - {Answer.projectedCostHigh ?? "unknown"} 
        </Typography>
        : null
        }
        {Answer.Solutions.sort((a,b) => a.Difficulty < b.Difficulty ? -1 : 1).map((solution: Solution, index: number) => (
          <AccordianSolutionComponent key={index} solution={solution} index={index}></AccordianSolutionComponent>
        ))} 
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Help Videos</Typography>
          </AccordionSummary>
          <AccordionDetails>
             <HelpVideoAccordianComponent VideoLinks={videoLinks ?? []} />
           </AccordionDetails>
        </Accordion>
{/*         <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Professionals in Your Area</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ProfessionalNearbyComponent answer={Answer} />
          </AccordionDetails>
        </Accordion> */}
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }} style={{marginTop:15}}>
          Disclaimer: The information provided by Fxer.AI, including repair instructions, estimates, and projections, is based on available data and should be considered as educated guesses. We are not liable for any issues that may arise from using this information. Always consult a professional for specific repair needs.        
        </Typography>
      </Box>
    </Container>
  );
};

export default IssueAnswerComponent;
